// src/hooks/useSessionCleanup.js
import { useEffect, useRef } from 'react';


const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

// Reusable session end function
export function endSession(subscriptionId) {
  if (!subscriptionId) {
    console.warn('[endSession] No subscriptionId provided');
    return;
  }
  try {
    const payload = JSON.stringify({ subscriptionId });
    const blob = new Blob([payload], { type: 'application/json' });
    const endEndpoint = `${API_BASE}/api/session/end`;
    console.log(`[endSession] Sending session end request for subscriptionId:`, subscriptionId);
    let beaconSent = false;
    if (typeof navigator.sendBeacon === 'function') {
      beaconSent = navigator.sendBeacon(endEndpoint, blob);
      console.log(`[endSession] sendBeacon result:`, beaconSent);
    }
    if (beaconSent === false) {
      fetch(endEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: payload,
        keepalive: true,
      })
        .then(res => {
          console.log(`[endSession] fetch response status:`, res.status);
          return res.json().then(data => {
            console.log(`[endSession] fetch response data:`, data);
          });
        })
        .catch(err => {
          console.error('[endSession] fetch error:', err);
        });
    }
  } catch (err) {
    console.error('[endSession] error:', err);
  }
}

export const useSessionCleanup = (subscriptionId, isSubmitted) => {
  // ✅ Hooks must be top-level (not inside useEffect)
  const sentOnceRef = useRef(false);

  useEffect(() => {
    if (!subscriptionId || !isSubmitted) return;

    sentOnceRef.current = false;
    const endOnHide = (process.env.REACT_APP_END_SESSION_ON_HIDE || '0').trim() === '1';

    const endSessionOnce = () => {
      if (sentOnceRef.current) return;
      sentOnceRef.current = true;
      endSession(subscriptionId);
    };

    const onPageHide = () => endSessionOnce();
    const onBeforeUnload = () => endSessionOnce();
    const onVisibilityChange = () => {
      if (!endOnHide) return;
      if (document.visibilityState === 'hidden') endSessionOnce();
    };

    window.addEventListener('pagehide', onPageHide);
    window.addEventListener('beforeunload', onBeforeUnload);
    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      window.removeEventListener('pagehide', onPageHide);
      window.removeEventListener('beforeunload', onBeforeUnload);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, [subscriptionId, isSubmitted]);
};
